if (!global._babelPolyfill) require("@babel/polyfill");
